// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_filtroContainer__Y3MxM {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 0;
  margin-bottom: 0;
}

.styles_selectColuna__ESMG9 {
  min-width: 250px !important;
  width: 250px !important;
}

.styles_selectColuna__ESMG9 > div {
  min-width: 250px !important;
}

.styles_selectColuna__ESMG9 .styles_MuiSelect-select__gBLxQ {
  min-width: 250px !important;
}

.styles_campoWrapper__9yrJ- {
  flex: 1 1;
  min-width: 200px;
  max-width: 300px;
}

.styles_campoFiltro__wPozb {
  width: 100%;
}

.styles_botaoFiltrar__qIQKZ {
  align-items: center !important;
  background-color: #18316e !important;
  background: #18316e !important;
  border: none !important;
  border-radius: 4px !important;
  color: #fff !important;
  cursor: pointer !important;
  display: flex !important;
  justify-content: center !important;
  padding: 0.5rem 1.5rem !important;
  gap: 0.5rem !important;
  font-size: 1rem !important;
  font-family: "Inter" !important;
  font-weight: normal !important;
  transition: transform 0.3s ease-in-out !important;
  box-shadow: none !important;
  text-transform: none !important;
  height: 40px !important;
  min-width: 120px !important;
  text-align: center !important;
}

.styles_botaoFiltrar__qIQKZ:hover {
  transform: scale(1.1) !important;
}

.styles_botaoFiltrar__qIQKZ:active {
  background-color: #1976d2 !important;
  background: #1976d2 !important;
}

.styles_botaoFiltrar__qIQKZ:disabled {
  background-color: #6b6e76 !important;
  background: #6b6e76 !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

.styles_botaoFiltrar__qIQKZ:focus {
  background-color: #18316e !important;
  background: #18316e !important;
  outline: none !important;
}

.styles_disabledButton__kqwni {
  background-color: #6b6e76 !important;
  cursor: not-allowed !important;
  color: #fff !important;
  text-align: center !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  border: none !important;
  gap: 5px !important;
  font-family: "Inter" !important;
  font-size: 1rem !important;
  transition: none !important;
  border-radius: 4px !important;
  padding: 0.5rem 1.5rem !important;
  min-width: 120px !important;
  height: 40px !important;
  opacity: 0.6 !important;
}

.styles_botaoLimpar__UT596 {
  background-color: #fff !important;
  background: #fff !important;
  border: 1px solid #18316e !important;
  border-color: #18316e !important;
  color: #18316e !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 0.5rem 1.5rem !important;
  border-radius: 4px !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 0.5rem !important;
  font-size: 1rem !important;
  font-family: "Inter" !important;
  transition: transform 0.3s ease-in-out !important;
  height: 40px !important;
  min-width: 120px !important;
}

.styles_botaoLimpar__UT596:hover {
  transform: scale(1.1) !important;
}

.styles_botaoLimpar__UT596:active {
  background-color: #f8f9fa !important;
  background: #f8f9fa !important;
}

@media (max-width: 768px) {
  .styles_filtroContainer__Y3MxM {
    flex-direction: column;
    align-items: stretch;
  }

  .styles_selectColuna__ESMG9,
  .styles_campoWrapper__9yrJ- {
    width: 100%;
    max-width: 100%;
  }

  .styles_botaoFiltrar__qIQKZ,
  .styles_botaoLimpar__UT596 {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/PisCofins/FiltroTabelaPisCofins/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,kCAAkC;EAClC,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,iDAAiD;EACjD,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,iDAAiD;EACjD,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".filtroContainer {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.selectColuna {\n  min-width: 250px !important;\n  width: 250px !important;\n}\n\n.selectColuna > div {\n  min-width: 250px !important;\n}\n\n.selectColuna .MuiSelect-select {\n  min-width: 250px !important;\n}\n\n.campoWrapper {\n  flex: 1;\n  min-width: 200px;\n  max-width: 300px;\n}\n\n.campoFiltro {\n  width: 100%;\n}\n\n.botaoFiltrar {\n  align-items: center !important;\n  background-color: #18316e !important;\n  background: #18316e !important;\n  border: none !important;\n  border-radius: 4px !important;\n  color: #fff !important;\n  cursor: pointer !important;\n  display: flex !important;\n  justify-content: center !important;\n  padding: 0.5rem 1.5rem !important;\n  gap: 0.5rem !important;\n  font-size: 1rem !important;\n  font-family: \"Inter\" !important;\n  font-weight: normal !important;\n  transition: transform 0.3s ease-in-out !important;\n  box-shadow: none !important;\n  text-transform: none !important;\n  height: 40px !important;\n  min-width: 120px !important;\n  text-align: center !important;\n}\n\n.botaoFiltrar:hover {\n  transform: scale(1.1) !important;\n}\n\n.botaoFiltrar:active {\n  background-color: #1976d2 !important;\n  background: #1976d2 !important;\n}\n\n.botaoFiltrar:disabled {\n  background-color: #6b6e76 !important;\n  background: #6b6e76 !important;\n  cursor: not-allowed !important;\n  opacity: 0.6 !important;\n}\n\n.botaoFiltrar:focus {\n  background-color: #18316e !important;\n  background: #18316e !important;\n  outline: none !important;\n}\n\n.disabledButton {\n  background-color: #6b6e76 !important;\n  cursor: not-allowed !important;\n  color: #fff !important;\n  text-align: center !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  border: none !important;\n  gap: 5px !important;\n  font-family: \"Inter\" !important;\n  font-size: 1rem !important;\n  transition: none !important;\n  border-radius: 4px !important;\n  padding: 0.5rem 1.5rem !important;\n  min-width: 120px !important;\n  height: 40px !important;\n  opacity: 0.6 !important;\n}\n\n.botaoLimpar {\n  background-color: #fff !important;\n  background: #fff !important;\n  border: 1px solid #18316e !important;\n  border-color: #18316e !important;\n  color: #18316e !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  padding: 0.5rem 1.5rem !important;\n  border-radius: 4px !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 0.5rem !important;\n  font-size: 1rem !important;\n  font-family: \"Inter\" !important;\n  transition: transform 0.3s ease-in-out !important;\n  height: 40px !important;\n  min-width: 120px !important;\n}\n\n.botaoLimpar:hover {\n  transform: scale(1.1) !important;\n}\n\n.botaoLimpar:active {\n  background-color: #f8f9fa !important;\n  background: #f8f9fa !important;\n}\n\n@media (max-width: 768px) {\n  .filtroContainer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .selectColuna,\n  .campoWrapper {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .botaoFiltrar,\n  .botaoLimpar {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filtroContainer": `styles_filtroContainer__Y3MxM`,
	"selectColuna": `styles_selectColuna__ESMG9`,
	"MuiSelect-select": `styles_MuiSelect-select__gBLxQ`,
	"campoWrapper": `styles_campoWrapper__9yrJ-`,
	"campoFiltro": `styles_campoFiltro__wPozb`,
	"botaoFiltrar": `styles_botaoFiltrar__qIQKZ`,
	"disabledButton": `styles_disabledButton__kqwni`,
	"botaoLimpar": `styles_botaoLimpar__UT596`
};
export default ___CSS_LOADER_EXPORT___;
